import { Component, Inject, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { Subscription } from 'rxjs';
import {MessengerService} from '../../services/messenger.service';
import { DialogButtonComponent } from "../buttons/dialog-button.component";
import { LoadingSpinnerComponent } from "../ui/loading-spinner-component";
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [DialogButtonComponent, LoadingSpinnerComponent, CommonModule],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-80">
      <div class="p-6">
        <h2 class="text-xl font-bold mb-4">{{ modalData?.title }}</h2>
        <p>{{ modalData?.message }}</p>
        <div class="mt-4 flex gap-2 justify-end">
          <app-dialog-button
            [text]="modalData?.abortText || 'Avbryt'"
            (onClick)="close(false)">
          </app-dialog-button>
          <app-dialog-button
            [text]="modalData?.confirmText || 'Bekräfta'"
            [disabled]="isWorking"
            (onClick)="confirm()"
            variant="primary">
          </app-dialog-button>
        </div>
      </div>
      <div *ngIf="isWorking" class="absolute bottom-10 left-0 right-0 w-full">
          <app-loading-spinner></app-loading-spinner>
       </div>
    </div>
  `
})
export class CallWaitressDialogComponent implements OnDestroy {
  modalData?: {
    title: string;
    message: string;
    confirmText?: string;
    abortText?: string;
    action?: string;
  };

  private sub = new Subscription();
  isWorking = false;
  table: string;
  private venueId: any;

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: any,
    private api: AuthorizedApiService,
    private messengerService: MessengerService
  ) {
    this.modalData = data;
    this.table = data.table;
    this.venueId = data.venueId;
  }

  close(value: any = false): void {
    this.modalService.close(value);
  }

  confirm(): void {
    this.isWorking = true;
    if (this.modalData?.action === 'callWaitress') {
      const sub = this.api.callForWaiter().subscribe(r => {
        this.isWorking = false;
        this.close(true);
      });
      this.sub.add(sub);
    }  else {
      this.close(false);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
